import Vue from 'vue'
import Router from 'vue-router'
import store from "@/store"


Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: 'login'
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login/login')
    },
    {
      path: '/home',
      component: () => import('@/views/home/home'),
      children: [
        {
          path: '',
          redirect: 'event-page'
        },
        {
          path: 'cash',
          name: 'cash',
          component: () => import('@/views/cash/cash'),
        },
        {
          path: 'event-page',
          name: 'event-page',
          component: () => import('@/views/event/event-page'),
        },
        {
          path: 'event',
          name: 'event',
          component: () => import('@/views/event/event'),
        },
        {
          path: 'customer',
          name: 'customer',
          component: () => import('@/views/customer/customer'),
        },
        {
          path: 'merchant',
          name: 'merchant',
          component: () => import('@/views/merchant/merchant'),
        }
      ]
    },
    {
      path: '*',
      name: 'error',
      component: () => import('@/views/error/error')
    }
  ]
})

const LOGIN_PAGE_NAME = 'login'

router.beforeEach((to, from, next) => {
  const isLogin = store.getters.token

  if (!isLogin && to.name !== LOGIN_PAGE_NAME) {
    next({name: LOGIN_PAGE_NAME})
  } else if (!isLogin && to.name === LOGIN_PAGE_NAME) {
    next()
  } else if (isLogin && to.name === LOGIN_PAGE_NAME) {
    next({
      name: 'event'
    })
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js